import * as axios from 'axios';
import store from '../store/store';

const HttpInterceptor = (function () {

    axios.interceptors.response.use((response) => {
        // console.log("interceptor http")
        return response
    },
        async function (error) {
            if ((!!error.response.data.errors && error.response.data.errors.length > 0) || !!error.response.data.Message) {

                console.log(error.response.data.errors, typeof error.response.data.errors);


                store.state.errorDialog = true;

                console.log("error.response.data.message: " + error.response.data.Message)

                // set error message for dialog
                if (error.response.data.Message) {
                    store.state.errorDialogMessages = [error.response.data.Message];
                } else {
                    for (let key in error.response.data.errors) {
                        console.log("error: " + JSON.stringify(error.response.data.errors))
                        if (Object.prototype.hasOwnProperty.call(error.response.data.errors, key)) {
                            // if (error.response.data.errors.hasOwnProperty(key)) {
                            let string = `${key}: ${error.response.data.errors[key]}`;
                            store.state.errorDialogMessages.push(string);
                        }
                    }

                }
            }

            // return Error object with Promise
            return Promise.reject(error.response.data);
        });

})();

export default HttpInterceptor;